<template>
    <div class="card border-0">
        <div class="card-header">
            <span> {{ planTitle(healthplan) }}</span>
        </div>
        <div class="card-body gray-bg">
            <ul class="list-group mb-3">
                <li class="list-group-item border-top-0 border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0">
                    <div class="row">
                        <div class="col-md-7 sb-benefit-list-title">
                            Coverage Amount
                        </div>
                        <div class="col-md-5  sb-benefit-list-value">
                            ${{ healthplan.coverage }}
                        </div>
                    </div>
                </li>
                <li class="list-group-item border-top-0 border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0">
                    <div class="row">
                        <div class="col-md-7 sb-benefit-list-title">
                            Product Type
                        </div>
                        <div class="col-md-5  sb-benefit-list-value">
                            {{ showProductType(healthplan.plancode) }}
                        </div>
                    </div>
                </li>
                <li v-if="false" class="list-group-item border-top-0 border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0">
                    <div class="row">
                        <div class="col-md-7 sb-benefit-list-title">
                            Supplemental Spouse
                        </div>
                        <div class="col-md-5  sb-benefit-list-value">
                            {{ getValue('Supplemental Spouse') }}
                        </div>
                    </div>
                </li>
                <li class="list-group-item border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0" v-if="healthplan.supplemental_amount">
                    <div class="row  ">
                        <div class="col-md-7 sb-benefit-list-title">
                            Supplemental Amount
                        </div>
                        <div class="col-md-5  sb-benefit-list-value">
                            ${{healthplan.supplemental_amount}}
                        </div>
                    </div>
                </li>
                <template v-if="showViewAll(healthplan)">
                    <div class="benefit-list-view-all">
                        <span class="benefit-list-view-all__title">Beneficiaries</span>
                        <span @click.prevent="openDetailedView(healthplan)"
                              class="benefit-list-view-all__btn"
                        >
                                    View All
                                </span>
                    </div>
                    <li v-if="dontShowBen" class="list-group-item border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0">
                        <div class="row  ">
                            <div class="col-md-7 sb-benefit-list-title">
                                Beneficiary Type
                            </div>
                            <div class="col-md-5  sb-benefit-list-value">
                                {{ healthplan.beneficiaries[0].type }}
                            </div>
                        </div>
                    </li>
                    <li v-if="dontShowBen" class="list-group-item border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0">
                        <div class="row  ">
                            <div class="col-md-7 sb-benefit-list-title">
                                Beneficiary
                            </div>
                            <div class="col-md-5  sb-benefit-list-value">
                                {{ healthplan.beneficiaries[0].first_name }} {{ healthplan.beneficiaries[0].last_name }}
                            </div>
                        </div>
                    </li>
                    <li v-if="dontShowBen" class="list-group-item border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0">
                        <div class="row  ">
                            <div class="col-md-7 sb-benefit-list-title">
                                Percentage
                            </div>
                            <div class="col-md-5  sb-benefit-list-value">
                                {{ healthplan.beneficiaries[0].beneficiary_percent }}
                            </div>
                        </div>
                    </li>
                    <li v-if="!dontShowBen" class="font-italic list-group-item border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0">
                        <div class="row  ">
                            <div class="col-md-12  sb-benefit-list-value">
                                We are working on getting all of your account information loaded, including beneficiary information. This may take up to two business days. Stay tuned!
                            </div>
                        </div>
                    </li>
                </template>
            </ul>
            <div class="text-center mb-3 btn-hp">
                <a href="#" v-if="!healthplan.hpd_parentid" @click.prevent="openDetailedView(healthplan)" class="btn-primary btn">
                    View Details
                </a>
                <a href="#" v-if="healthplan.provider && ssoButtonText(healthplan.provider)" @click.prevent="ssoBtnClick(healthplan)" class="btn-primary btn">
                    {{ ssoButtonText(healthplan.provider) }}
                </a>
                <a href="#" v-else-if="healthplan.payments.length > 0"
                   @click="openPayments(healthplan)"
                   class="btn-primary btn"
                >
                    View All Payments
                </a>
            </div>
        </div>
        <div id="sso" v-html="sso" ref="sso"></div>
    </div>
</template>

<script>

export default {
    name: "PlanCardOtherGTLI",
    props: ['healthplan'],
    data() {
        return {
            dontShowBen:true,
            sso:''
        }
    },
    computed: {
    },
    methods: {
        ssoBtnClick(healthplan){
            if(healthplan.hpd_parentid){
                this.ssoClick();
            }else{
                this.openDetailedView(healthplan)
            }
        },
        ssoClick() {
            document.getElementById("overlay").style.display = "flex";
            axios
                .get('/api/sso/' + this.healthplan.provider.toLowerCase())
                .then(res => {
                    this.sso = res.data.html;
                }).then(() => {
                this.$refs.sso.children[3].target = '_blank';
                this.$refs.sso.children[3].submit();
                document.getElementById("overlay").style.display = "none";
            });
        },
        planTitle(healthplan){
            return this.$parent.planTitle(healthplan);
        },
        showViewAll(healthplan){
            return this.$parent.showViewAll(healthplan);
        },
        openDetailedView(healthplan){
            this.$parent.openDetailedView(healthplan);
        },
        getHpSummaryFields(fields, type){
            return this.$parent.getHpSummaryFields(fields, type);
        },
        ssoButtonText(provider){
            return this.$parent.ssoButtonText(provider);
        },
        openPayments(healthplan){
            this.$parent.openPayments(healthplan);
        },
        showProductType(value){
            return this.$parent.showProductType(value);
        },
        showValues(value){
            switch (value){
                case '$50 co-pay, waived if admitted':
                    return '$50';
                    break;
                case '$200 co-pay, waived if admitted':
                    return '$200';
                    break;
                default:
                    return value;
            }

        },
        findField(fields, label) {
            return this.$parent.findField(fields, label);
        },
        getValue(label) {
            return this.findField(this.healthplan.hpd_fields, label)[0]?.value;
        }
    },
}
</script>

<style scoped>

</style>
